import { render, staticRenderFns } from "./anshinDetail.vue?vue&type=template&id=7629ce49&"
import script from "./anshinDetail.vue?vue&type=script&lang=js&"
export * from "./anshinDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports